import { __ } from '@wordpress/i18n';

import p1 from '../../assets/public/img/template/preview_1.webp';

const adminSelectedStyle = [
    {
        value: 'style1',
        label: __( 'Style 1', 'cv-builder' ),
        imageUrl: p1
    },
];

export default adminSelectedStyle;